/**
 * @file TransferNotices.tsx
 * @description Полосы-пояснения документа «Перемещение» (вынесено из
 * `WmsTransferEditPage` в phase19.31, чтобы страница осталась раскладкой
 * ≤200 строк): комментарий, «черновик остаток не двигает», позиции без
 * партии в листе размещения, ошибка справочника формы.
 *
 * «Размещать нечего» здесь больше не пишется: тот же текст стоит в пустом
 * списке позиций, и на 360 он шёл дважды подряд (QA-5 D11). Позиции без
 * партии — полосой, только пока список не пуст (иначе их объясняет он).
 */

import { NoticeStrip } from "../../ui/NoticeStrip";

interface Props {
  notes: string | null;
  isDraft: boolean;
  /** Позиции приёмки без партии — в лист размещения не попали (при непустом списке). */
  unplaceableText: string | null;
  /** Не загрузился справочник остатков формы строки. */
  optionsError: string | null;
}

export function TransferNotices({ notes, isDraft, unplaceableText, optionsError }: Props) {
  return (
    <>
      {notes ? (
        <NoticeStrip tone="info" title="Комментарий">
          {notes}
        </NoticeStrip>
      ) : null}
      {isDraft ? (
        <NoticeStrip tone="info">
          Черновик остаток не двигает. Адреса и склады изменятся после кнопки «Провести перемещение».
        </NoticeStrip>
      ) : null}
      {unplaceableText ? <NoticeStrip tone="warning">{unplaceableText}</NoticeStrip> : null}
      {optionsError ? <NoticeStrip tone="error">{optionsError}</NoticeStrip> : null}
    </>
  );
}
